import { ChangeEventHandler, memo } from 'react';

import TextField from '@mui/material/TextField';

import { SELECT_REWARDS } from '../constants';

import { useFormSelects } from 'v2/components/form/hooks';
import { Select } from 'v2/components/select/Select';
import { UserRewardType } from 'v2/constants';
import { enumToSelect } from 'v2/utils';

interface SingleRewardPickerProps {
  rewardType: UserRewardType;
  onRewardTypeChange: (value: UserRewardType) => void;
  rewardValue: string;
  onRewardValueChange: (value: string) => void;
  disabled?: boolean;
  required?: boolean;
}

export const SingleRewardPicker = memo<SingleRewardPickerProps>(
  ({ rewardType, onRewardTypeChange, rewardValue, onRewardValueChange, disabled, required }) => {
    const { goldenTicketsOptions, contestTicketsOptions } = useFormSelects(rewardType);

    const handleRewardTypeChange = (value: UserRewardType) => {
      onRewardTypeChange(value);
      onRewardValueChange('');
    };

    const handleRewardValueChange: ChangeEventHandler<HTMLInputElement> = (e) => {
      onRewardValueChange(e.target.value);
    };

    return (
      <div className="form-group">
        <Select
          value={rewardType}
          options={enumToSelect(UserRewardType)}
          label="Reward Type"
          onChange={handleRewardTypeChange}
          disabled={disabled}
          required={required}
        />

        {rewardType === UserRewardType.GOLDEN_TICKET && (
          <Select
            value={rewardValue}
            options={goldenTicketsOptions}
            label="Reward Value"
            onChange={onRewardValueChange}
            required={required}
          />
        )}

        {rewardType === UserRewardType.CONTEST_TICKET && (
          <Select
            value={rewardValue}
            options={contestTicketsOptions}
            label="Reward Value"
            onChange={onRewardValueChange}
            required={required}
          />
        )}

        {!SELECT_REWARDS.includes(rewardType) && (
          <TextField
            value={rewardValue}
            onChange={handleRewardValueChange}
            label="Reward Value"
            disabled={disabled}
            fullWidth
            required={required}
          />
        )}
      </div>
    );
  }
);

SingleRewardPicker.displayName = 'SingleRewardPicker';
